import React, { Component } from 'react';
import './Preloader.css'

export default class ScatterGraph extends Component {
    render() {
        return (
            <div id="radar" {...this.props}>
                <div className="preloader-spinner" aria-label="loading" />
            </div>
        );
    }
}